module.exports = __webpack_public_path__ + "img/Comdirect_icon.9b9a2c07.png";